import { BrandProtectedComponent, TableActionsWrapper } from '@components'

import React, { ReactElement } from 'react'

import { ContactsArchivedFilter } from './elements/ContactsArchivedFilter'
import { ContactsSearch } from './elements/ContactsSearch'
import { ContactsTitle } from './elements/ContactsTitle'

export const ContactsTableActions = ({ title }: { title: string }): ReactElement => {
  return (
    <TableActionsWrapper>
      <ContactsTitle title={title} />
      <ContactsSearch />
      <BrandProtectedComponent brand="billy">
        <ContactsArchivedFilter />
      </BrandProtectedComponent>
    </TableActionsWrapper>
  )
}
